import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowModelSummaryList from './FlowModelSummaryList';
const FlowModelSummaryListBridge = react2angular(FlowModelSummaryList, [
  'flowModels',
  'isMobile',
  'onFlowModelClicked'
]);
export default FlowModelSummaryListBridge;
